import { useMultiselectContext as t } from "./index.es5614.js";
function n() {
  return t().multiSelectDropdownMenuState;
}
export {
  n as useMultiselectState
};
//# sourceMappingURL=index.es2489.js.map
